<template>
  <div class="app-container">
    <div class="card">
      <el-form
        ref="form"
        :model="queryParams"
        :inline="true"
        @keyup.enter.native="handleQuery"
      >
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.unitName"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="接收公司：">
          <el-input
            v-model="queryParams.receiveUnitName"
            placeholder="请输入接收公司"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="queryParams.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mainContainer">
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column prop="id" label="发送编号" align="center" />
          <el-table-column prop="unitName" label="企业名称" align="center" />
          <el-table-column prop="certificateNumber" label="证件编号" align="center" />
          <el-table-column prop="receiveUnitName" label="接收公司" align="center" />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{ row }">
              {{ getStatusLabel(row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="sender" label="发送人" align="center" />
          <el-table-column prop="sendTime" label="发送时间" align="center" />
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{ row }">
              <span class="btsed" @click="openSnapshot(row)">资料快照</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <CustInformation
      v-model="snapshotVisible"
      :customerId="snapshotRow.customerId"
      :routerType="2"
      entryMode="snapshot"
      @closed="snapshotVisible = false"
    />
  </div>
</template>

<script>
import { getQualificationShareRecord } from "@/api/appApi/appapi.js";
export default {
  name: "",
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        unitName: "", //企业名称
        receiveUnitName: "", //接收公司
        status: "", //状态
      },

      statusOptions: [
        { label: "待审核", value: "1" },
        { label: "已接收", value: "2" },
        { label: "已拒绝", value: "3" },
      ],

      total: 0,
      loading: false,
      tableData: [], //列表

      snapshotVisible: false,
      snapshotRow: {},
    };
  },

  created() {
    if (this.$route.query) {
      console.log(this.$route.query, "this.$route.query");
    }
    this.getList();
  },
  methods: {
    //序号
    indexMethod(index) {
      index + (this.queryParams.currPage - 1) * this.queryParams.pageSize + 1;
    },

    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      const params = {
        type: 1, // 1:发送记录
        unitName: this.queryParams.unitName,
        receiveUnitName: this.queryParams.receiveUnitName,
        status: this.queryParams.status,
        pageNumber: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
      };
      const res = await getQualificationShareRecord(params);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list || [];
        this.total = res.content.totalRecords || 0;
      }
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    openSnapshot(row) {
      this.snapshotRow = row || {};
      this.snapshotVisible = true;
    },
    getStatusLabel(status) {
      const val = String(status ?? "");
      if (val === "1") return "待审核";
      if (val === "2") return "已接收";
      if (val === "3") return "已拒绝";
      return status || "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
